import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsKitesurfNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M29.46 26.49l-7.07 3.76.01.01.76 1.45 7.07-3.76-.76-1.45-.01-.01zM23.13.17a16.16 16.16 0 00-6.98 1.85l-1.09.58h-.01L9.52 5.55a15.988 15.988 0 00-5.43 4.71 5.465 5.465 0 00-.97 4.2 5.522 5.522 0 002.36 3.63l16.01 10.79 2.17-1.15-12.85-13.85a3.858 3.858 0 01-.52-4.58c.097-.17.204-.333.32-.49-.91.56-1.744 1.235-2.48 2.01-.041.589.013 1.18.161 1.752l-3.482 1.854a1.23 1.23 0 01-.059-.256 3.808 3.808 0 01.67-2.94 15.545 15.545 0 016.02-4.84 14.413 14.413 0 017.4-1.62 3.864 3.864 0 013.53 2.99l4.3 18.36 2.16-1.15V5.7A5.516 5.516 0 0025.297.546 5.582 5.582 0 0023.13.17zM8.932 14.1c.19.323.414.625.668.9l9.61 10.36L6.4 16.72a3.751 3.751 0 01-.869-.809L8.932 14.1zM18.96 3.13c-.43-.03-.86-.03-1.29-.02a14.34 14.34 0 015.51-1.29A3.8 3.8 0 0126 2.92c.05.05.1.1.149.159l-3.468 1.842A5.457 5.457 0 0018.96 3.13zm8.22 17.93L23.97 7.38a5.707 5.707 0 00-.37-1.073L26.99 4.5c.13.387.194.792.19 1.2v15.36z"
        fill=""
      />
    </svg>
  )
);
SvgSportsKitesurfNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsKitesurfNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsKitesurfNormalMedium;
